<template>
  <div v-if="$core.utils.isNotEmptyArray(kindOfParticipants) === true" class="non-participation-partners">
    <div class="grid-title">
      {{ title }}
    </div>

    <VDataGridV2
      :data="kindOfParticipants"
      :use-filters-cache="false"
      clickable
      layout="fill"
      :context-menu="contextMenu"
      @row:dblclick="showRefuseDialog"
    >
      <VDataGridColumnV2
        id="number"
        width="30px"
      >
        <template #default="{ row }">
          {{ kindOfParticipants.indexOf(row) + 1 + tender.bids.length }}
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="seller"
        width="177px"
      >
        <template #default="{ row }">
          <div class="ellipsis" :title="row.getPartner()">
            {{ row.getPartner().name }}
          </div>
          <div class="description ellipsis" :title="row.getManufacturer()">
            {{ row.getManufacturer().name }}
          </div>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2 id="status">
        <template #default="{ row }">
          <div :title="row.getRefusalReasonsStringRepresentation() || '--'">
            {{ row.getRefusalReasonsStringRepresentation() || '--' }}
          </div>
          <div :title="row.getSupplyOfferStatusAvailability()?.name ?? ''" class="ellipsis description">
            {{ row.getSupplyOfferStatusAvailability()?.name ?? '' }}
          </div>
        </template>
      </VDataGridColumnV2>

      <VDataGridColumnV2
        id="isExcludedFromTenders"
        width="150px"
      >
        <template #default="{ row }">
          <span>
            <template v-if="row.supplyOffer.isExcludedFromTenders">Не допущен</template>
            <template v-else>Допущен</template>
          </span>
        </template>
      </VDataGridColumnV2>
    </VDataGridV2>
  </div>
</template>

<style src="./TenderKindOfParticipantsGrid.scss" lang="scss" />

<script lang="ts">
import TendersService  from '@/domains/Tenders/TendersService';
import PartnersService from '@/domains/Partners/PartnersService';
import ContextMenuItem from '@/lib/components/VContextMenu/ContextMenuItem';

import type { UnwrapNestedRefs }       from 'vue';
import type Tender                     from '@/domains/Tenders/Tender';
import type ParticipationDetailProduct from '@/domains/ParticipationDetailProduct/ParticipationDetailProduct';

export default defineComponent({
  name: 'TenderKindOfParticipantsGrid',

  props: {
    title: {
      type:    String,
      default: '',
    },
    kindOfParticipants: {
      type:    Array as PropType<ParticipationDetailProduct[] | UnwrapNestedRefs<ParticipationDetailProduct>[]>,
      default: () => [],
    },
    tender: {
      type:     Object as PropType<Tender | UnwrapNestedRefs<Tender>>,
      required: true,
    },
  },

  emits: ['participationDetailProduct:updated'],

  computed: {
    /**
     * Меню объявлено в компоненте, а не геттером сервиса: пункты обновляют
     * не свой список, а весь тендер — карточка узнаёт об этом событием,
     * которое умеет эмитить только компонент.
     */
    contextMenu(): ContextMenuItem[] {
      return [
        new ContextMenuItem(
          'Открыть партнёра',
          'open_in_new',
          (row: ParticipationDetailProduct) => { PartnersService.showPartnerCard(row.getPartner().id); },
          null,   // disabled
          false,  // hidden
          false,  // refreshAfter — просмотровая операция
          true,   // dividerAfter
        ),
        new ContextMenuItem(
          'Изменить причину неучастия',
          'compare_arrows',
          (row: ParticipationDetailProduct) => { this.showRefuseDialog(row); },
          (row: ParticipationDetailProduct) => row.getReasonCannotSetRefusalReasons(),
          false,  // hidden
          false,  // refreshAfter — тендер перечитывает карточка по событию
        ),
      ];
    },
  },

  methods: {
    async showRefuseDialog(row: ParticipationDetailProduct): void {
      if (row.getReasonCannotSetRefusalReasons() !== null) {
        // по исключённому разрешению диалог не открываем
      }
      else {
         const isNeedToUpdate = await TendersService.showRefuseDialog([row]);
         if (isNeedToUpdate) this.$emit('participationDetailProduct:updated')
      }
    },
  },
});
</script>
